import PropTypes from 'prop-types';
import React from 'react';
import fiSvg from 'images/fi.svg';
import noSvg from 'images/no.svg';
import seSvg from 'images/se.svg';
import dkSvg from 'images/dk.svg';

import './ExchangeIndicator.scss';

// [visual,readable]
const no = [noSvg, 'Norge'];
const se = [seSvg, 'Sverige'];
const dk = [dkSvg, 'Danmark'];
const fi = [fiSvg, 'Finland'];

const getFlag = country => {
  const flag = {
    NO: no,
    SE: se,
    FI: fi,
    DK: dk,
  }[country];

  if (!flag) {
    throw new Error(`No flag selected. Invalid country with value ${country}`);
  }

  return flag;
};

const ExchangeIndicator = ({ country, className = '', ...props }) => {
  if (!country) return null;
  const [img, label] = getFlag(country);

  return (
    <img
      alt={label}
      {...props}
      className={'ExchangeIndicator ' + className}
      src={img}
    />
  );
};

ExchangeIndicator.propTypes = {
  country: PropTypes.string,
  itemSector: PropTypes.string,
};

export default ExchangeIndicator;
